import api from '@/api/agreement'

const state = {
}

const actions = {
  getSystemPolicyById (context, params) {
    return api.getSystemPolicyById(params)
  },
  getSystemPolicyByType (context, params) {
    return api.getSystemPolicyByType(params)
  },
  getSystemPolicyList () {
    return api.getSystemPolicyList()
  },
  updateSystemPolicy (context, params) {
    return api.updateSystemPolicy(params)
  },
  saveSystemPolicy (context, params) {
    return api.saveSystemPolicy(params)
  },
  deleteSystemPolicy (context, params) {
    return api.deleteSystemPolicy(params)
  },
  getCompanyPolicyList () {
    return api.getCompanyPolicyList()
  },
  getCompanyPolicyById (context, policyId) {
    return api.getCompanyPolicyById(policyId)
  },
  createCompanyPolicy (context, policyInfo) {
    return api.createCompanyPolicy(policyInfo)
  },
  updateCompanyPolicy (context, { policyId, policyInfo }) {
    return api.updateCompanyPolicy(policyId, policyInfo)
  },
  deleteCompanyPolicy (context, policyId) {
    return api.deleteCompanyPolicy(policyId)
  },
  deleteCompanyPolicyFile (context, params) {
    return api.deleteCompanyPolicyFile(params)
  },
  getCompanyPolicyItemList (context, params) {
    return api.getCompanyPolicyItemList(params)
  },
  revokeApplication (context, applicationInfo) {
    return api.revokeApplication(applicationInfo)
  },
  revokeAllApplication (context, candidateInfo) {
    return api.revokeAllApplication(candidateInfo)
  },
  inviteCandidateAgreeConsent (context, params) {
    return api.inviteCandidateAgreeConsent(params)
  },
  getCandidateAgreeConsentLink (context, params) {
    return api.getCandidateAgreeConsentLink(params)
  }
}

const mutations = {

}

const getters = {

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
